import * as classnames from "classnames";
import * as React from "react";

import {
  PageTitle,
  PageSubTitle,
  HeroTile,
  Msg,
} from "../../../../shared/components";

/**
 * Page component
 */
class ExamInvitationComplete extends React.Component {
  public render() {
    const rootStyle = classnames("code-exam-invitation-complete");

    return (
      <div className={rootStyle}>
        <HeroTile>
          <PageTitle>
            <Msg id="editor.urlDeliverySteps.receiveEmail.navigateTitle" />
          </PageTitle>
          <p>
            <Msg id="editor.urlDeliverySteps.receiveEmail.navigateText1" />
          </p>
          <ol>
            <Msg id="editor.urlDeliverySteps.receiveEmail.navigateText2" />
          </ol>
          <div className="code-exam-invitation-complete__steps">
            <PageSubTitle>
              <Msg id="editor.takeExam.steps" />
            </PageSubTitle>
            <ul className="steps has-content-centered">
              <li className="steps-segment">
                <span className="steps-marker">1</span>
                <div className="steps-content">
                  <PageSubTitle>
                    <Msg id="editor.urlDeliverySteps.deliverEmail" />
                  </PageSubTitle>
                </div>
              </li>
              <li className="steps-segment is-active  is-dashed">
                <span className="steps-marker">2</span>
                <div className="steps-content">
                  <PageSubTitle>
                    <Msg id="editor.urlDeliverySteps.receiveEmail" />
                  </PageSubTitle>
                </div>
              </li>
              <li className="steps-segment is-dashed">
                <span className="steps-marker">3</span>
                <div className="steps-content">
                  <PageSubTitle>
                    <Msg id="editor.urlDeliverySteps.accessToExam" />
                  </PageSubTitle>
                </div>
              </li>
            </ul>
          </div>
        </HeroTile>
      </div>
    );
  }
}

export default ExamInvitationComplete;
